import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, isAuthenticated }) => {
  // If the user is not authenticated, redirect them to the login page
  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace />;
  }
  // If authenticated, render the children components (e.g., Dashboard)
  return children;
};

export default ProtectedRoute;